module.exports = __webpack_public_path__ + "img/ouvaton.png";